import { render, staticRenderFns } from "./TwIvPdf.vue?vue&type=template&id=a185d584&scoped=true&"
import script from "./TwIvPdf.vue?vue&type=script&lang=js&"
export * from "./TwIvPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a185d584",
  null
  
)

export default component.exports